import { Routes, Route } from "react-router-dom";
import InputPage from "./pages/InputPage.js";
import GalaxyPage from "./pages/GalaxyPage.js";

function App() {
  return (
 <Routes>
      <Route path="/" element={<InputPage />} />
      <Route path="/galaxy" element={<GalaxyPage />} />
    </Routes>
  );
}

export default App;
